import { HttpService } from '@services/http.service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export default class AuthService {
  constructor(
    private httpS: HttpService
  ) { }


  getApiVersion(apiBaseurl) {
    return this.httpS.get(`/version`, {}, {}, 'public', apiBaseurl);
  }

  register(payload: any, channel = 'public') {
    return this.httpS.post(`/auth/register`, payload, {}, channel);
  }

  login(payload: any, channel = 'public') {
    return this.httpS.post(`/auth/login`, payload);
  }

  userInfo(payload: any, channel = 'public') {
    return this.httpS.get(`/auth/user/${payload.id}`);
  }

  logout() {
    // console.log('logout. remove jwt token.');
    localStorage.removeItem('id');
    localStorage.removeItem('name');
    localStorage.removeItem('login_platform');
    localStorage.removeItem('jwt_token');
  }

  changePassword(payload: any, channel = 'public') {
    return this.httpS.put(`/auth/change-password`, payload, {}, channel);
  }

  resetPassword(payload: any, channel = 'public') {
    return this.httpS.put(`/auth/reset-password`, payload, {}, channel);
  }

  // getUrlLanding(user_id: any, channel = 'public') {
  //   return this.httpS.get(`/auth/url-landing/${user_id}`, {}, {}, channel);
  // }

  // getSettings(user_id: any, channel = 'public') {
  //   return this.httpS.get(`/auth/setting`, {}, {}, channel);
  // }

  // updatesettings(requestOpt) {
  //   return this.httpS.put(`/auth/setting`, requestOpt);
  // }
}

export { AuthService };
